"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DealSummaryLabels = void 0;
var DealSummaryLabels;
(function (DealSummaryLabels) {
    DealSummaryLabels["SEPARATOR"] = "------------";
    DealSummaryLabels["ADVERTISED_PRICE"] = "Advertised Price";
    DealSummaryLabels["MSRP"] = "MSRP";
    DealSummaryLabels["MSRP_INFO"] = "";
    DealSummaryLabels["AMT_FINANCED_LEASE"] = "Est. Adjusted Cap Cost";
    DealSummaryLabels["AMT_FINANCED_FINANCE"] = "Total Financed";
    DealSummaryLabels["ANNUAL_MILES"] = "Annual Miles";
    DealSummaryLabels["APR"] = "APR";
    DealSummaryLabels["DMV_FEES"] = "DMV Fees";
    DealSummaryLabels["INCENTIVES"] = "Specials";
    DealSummaryLabels["TAXES"] = "Taxes";
    DealSummaryLabels["TERM"] = "Term";
    DealSummaryLabels["PRICE_SINGLE"] = "My Price";
    DealSummaryLabels["PRICE_MULTI"] = "My Asking Price";
    DealSummaryLabels["DUE_AT_SIGNING"] = "Total Due At Signing";
    DealSummaryLabels["TRADE_ALLOWANCE"] = "Net Trade-in Value";
    DealSummaryLabels["DOWN_PAYMENT_FINANCE"] = "Cash Down";
    DealSummaryLabels["DOWN_PAYMENT_LEASE"] = "Down Payment";
    DealSummaryLabels["FIRST_MONTH_PAYMENT"] = "First Month Payment";
    DealSummaryLabels["CAP_COST_REDUCTION"] = "Cap Cost Reduction";
    DealSummaryLabels["SECURITY_DEPOSIT"] = "Security Deposit";
    DealSummaryLabels["DOCUMENTATION_FEE"] = "Documentation Fee";
    DealSummaryLabels["ACQUISITION_FEE"] = "Acquisition Fee";
    DealSummaryLabels["MANUFACTURER_INCENTIVES_NAME"] = "Manufacturer's Incentives";
})(DealSummaryLabels = exports.DealSummaryLabels || (exports.DealSummaryLabels = {}));
